import ProtocolInfo from './ProtocolInfo';

export default ProtocolInfo;
